import { z } from "zod";
import apiMaterialSchema from "./apiMaterialSchema";

const apiColorMaterialSchema = apiMaterialSchema.extend({
    color: z.string(),
    opacity: z.number()
  });

export default apiColorMaterialSchema;